/* 
 * Projects default javascript config for som_distribution package. This file 
 * contains a couple of configurations to build the websites interactive components. 
 * 
 * Configuration for following components:
 *	- Sticky header
 *	- Link to top
 *	- Mobile menu - mmenu
 *	- lightcase
 *	- Basic slider - Orbit slider
 *	- Advanced slider - Revolution slider
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

module.exports = {
		
	// Common project config
	// =============================================================================
	project: {
		devMode: true,
		configTranslationEnabled: false,
		events: {
			before: function(event, data) {},
			after: function(event, data) {}
		}
	},
	
	// Components config
	// =============================================================================
	components: {
		
		// Foundation
		foundation: {
			
			// Foundation orbit
			orbit: {
				enabled: true
			},
			
			// Foundation sticky
			sticky: {
				enabled: true
			},
			
			// Foundation accordeon
			accordion: {
				enabled: true
			},
			
			// Foundation tabs
			tabs: {
				enabled: true
			},

			// Foundation tooltip
			tooltip: {
				enabled: true
			}
		},
		
		// Scroll top
		scrolltop: {
			enabled: true,
			container: '.scroll-top',
			showScreenPercentage: 50 
		},
		
		// Mobile menu (mmmenu)
		mmenu: {
			enabled: true,
			container: {
				main: '.nav-mobile-container',
				control: '.nav-mobile-control'
			},
			mopt: {
				offCanvas: {
					position: 'left'
				},
				setSelected: {
					parent: true
				}
			},
			mconf: {
				offCanvas: {
					pageSelector: '.page'
				}
			}
		},
		
		// Lightcase
		lightcase: {
			enabled: true,
			selector: 'a[rel^="lightcase"]',
			config: {
				attr: 'rel',
				showTitle: true,
				showSequenceInfo: true,
				maxWidth: 1280,
				maxHeight: 960
			}
		},
		
		// jQuery focuspoint plugin
		focuspoint: {
			enabled: true,
			selector: '.focuspoint',
			config: {
				reCalcOnWindowResize: true,
				throttleDuration: 100
			}
		},

		// Autocomplete component for solr search
		solrautocomplete: {
			enabled: true,
			selector: '.tx-solr-q',
			config: {
				dataType: 'json',
				paramName: 'termOriginal'
			}
		}
	},

	// Language overrides
	langOverrides: {}
};




/** WEBPACK FOOTER **
 ** ./src/configs/default.config.js
 **/